import React from "react";

function Privacy() {
    return (
        <div id="main" className="wrapper">
            <div className="inner">
                <header className="page-header">
                    <h1>Privacy Policy</h1>
                    <p className="doc-meta">Last updated September 16, 2026</p>
                </header>
                <p>
                    When you visit our website or use services provided by
                    Reliance Litigation doing business as Reliance Litigation,
                    LLC (“Reliance Litigation”, ''we", "us", or “our'), we
                    understand you trust us with your information and we take
                    your privacy seriously. In this privacy policy, we seek to
                    explain to you in the clearest way possible what information
                    we collect, how we use it and what rights you have in
                    relation to it.
                </p>
                <p>
                    This privacy policy applies to all information collected
                    through our website (such as
                    http://www.reliancelitigation.com) and/or any related web
                    sites or domains that’s operated by Reliance Litigation to
                    provide customer and marketing services for our business
                    and/or third party companies (we refer to them collectively
                    in this privacy policy as the "Services").
                </p>
                <p>
                    We are committed to protecting your personal information and
                    your right to privacy. If you have any questions or concerns
                    about our policy or our practices with regards to your
                    personal information. please contact us at{" "}
                    <b>privacy@reliancelitigation.com</b>
                </p>
                <p>
                    Please read this privacy policy carefully as it will help
                    you make informed decisions about sharing your personal
                    information with us.
                </p>
                <h2>1. What Information Do We Collect?</h2>
                <p>Personal information you disclose to us</p>
                <p>
                    In Short: We collect personal information that you provide
                    to us such as name, email address, mailing address, survey,
                    and contact information.
                </p>
                <p>
                    We collect personal information that you voluntarily provide
                    to us when expressing an interest in obtaining information
                    about us or our products and services when participating in
                    activities on the Services or otherwise contacting us. The
                    personal information that we collect depends on the context
                    of your interactions with us and the Services the choices
                    you make and the products and features you use. The personal
                    information we collect can include the following:
                </p>
                <p>
                    Publicly Available Personal Information. We collect first
                    name, maiden name, last name, and nickname; ID; phone
                    numbers; email addresses; current and former address; birth,
                    and death records; family member names and their related
                    information; business email; business phone number; and
                    other similar data.
                </p>
                <p>
                    All personal information that you provide to us must be
                    true, complete, and accurate, and you must notify us of any
                    changes to such personal information
                </p>
                <h3>Information automatically collected</h3>
                <p>
                    In Short: Some information - such as IP address and/or
                    browser and device characteristics - is collected
                    automatically when you visit our Services.
                </p>
                <p>
                    We automatically collect certain information when you visit
                    use or navigate the Services. This information does not
                    reveal your specific identity (like your name or contact
                    information) but may include device and usage information,
                    such as your IP address, browser and device characteristics,
                    operating system, language preferences, referring URLs,
                    device name, country location. information about how and
                    when you use our Services and other technical information.
                    This information is primarily needed to maintain the
                    security and operation of our Services, and for our internal
                    analytics and reporting purposes.
                </p>
                <p>
                    Like many businesses, we also collect information through
                    cookies and similar technologies Online Identifiers. We
                    collect cookie identifiers or others such as the ones used
                    for analytics and marketing device's geolocation; devices;
                    applications; tools and protocols, such as IP (Internet
                    Protocol) addresses and other similar data.
                </p>
                <h3>Information collected from other sources</h3>
                <p>
                    In Short: We may collect limited data from public databases,
                    marketing partners, social media platforms, and other
                    outside sources.
                </p>
                <p>
                    We may obtain information about you from other sources, such
                    as public databases, joint marketing partners, digital
                    advertisement, social media platforms (such as Facebook) as
                    well as from other third parties. Examples of the
                    information we receive from other sources include: social
                    media profile information (your name, gender, birthday,
                    email, current city, state and country, user identification
                    numbers for your contacts, profile picture URL, and any
                    other information that you choose to make public); marketing
                    leads, search results, links, and advertising data provided
                    by our marketing partners including paid listings (such as
                    sponsored links).
                </p>
                <h2>2. How Do We Use Your Information?</h2>
                <p>
                    In Short: We process your information for purposes based on
                    legitimate business interests, the fulfillment of our
                    contract with you and our clients, compliance with our legal
                    obligations, and/or your consent.
                </p>
                <p>
                    We use personal information collected via our Services for a
                    variety of business purposes described below. We process
                    your personal information for these purposes in reliance on
                    our legitimate business interests in order to enter into or
                    perform a contract with you, with your consent, and/or for
                    compliance with our legal or business obligations. We
                    indicate the specific processing grounds we rely on next to
                    each purpose listed below.
                </p>
                <p>We use the information we collect or receive:</p>
                <ul>
                    <li>
                        To send you marketing and promotional communications. We
                        and/or our third party marketing partners may use the
                        personal information you send to us for our marketing
                        purposes, if this is in accordance with your marketing
                        preferences. You can opt-out of our marketing emails at
                        any time (see the "WHAT ARE YOUR PRIVACY RIGHTS" below).
                    </li>
                    <li>
                        To send administrative information to you. We may use
                        your personal information to send you product, service
                        and new feature information and/or information about
                        changes to our terms, conditions and policies
                    </li>
                    <li>
                        Fulfill and manage services or orders. We may use your
                        information to fulfill and manage your requests for our
                        Services.
                    </li>
                    <li>
                        To post testimonials. We post testimonials on our
                        Services that may contain personal information. Prior to
                        posting a testimonial. we will obtain your consent to
                        use your name and testimonial. If you wish to update. or
                        delete your testimonial, please contact us at
                        privacy@reliancelitigation.com and be sure to include
                        your name, testimonial location, and contact
                        information.
                    </li>
                    <li>
                        Deliver targeted advertising to you. We may use your
                        information to develop and display content and
                        advertising (and work with third parties who do so)
                        tailored to your interests nd/or location and to measure
                        its effectiveness.
                    </li>
                    <li>
                        Request Feedback. We may use your information to request
                        feedback and to contact you about your use of our
                        Services.
                    </li>
                    <li>
                        To protect our Services. We may use your information as
                        part of our efforts to keep our Services sale and secure
                        (for example, for fraud monitoring and prevention).
                    </li>
                    <li>
                        To enforce our terms, conditions and policies for
                        Business Purposes, Legal Reasons and Contractual.
                    </li>
                    <li>
                        To respond to legal requests and prevent harm. lf we
                        receive a subpoena or other legal request, we may need
                        to inspect the data we hold to determine how to respond.
                    </li>
                    <li>
                        To manage user accounts. We may use your information for
                        the purposes of managing our account and keeping it in
                        working order.
                    </li>
                    <li>
                        To deliver services to the user or our clients. We may
                        use your information to provide you with the requested
                        service.
                    </li>
                    <li>
                        To respond to user inquiries/offer support to users. We
                        may use your information to respond to your inquiries
                        and solve any potential issues you might have with the
                        use of our Services.
                    </li>
                    <li>
                        For other Business Purposes. We may use your information
                        for other Business Purposes. such as data analysis,
                        identifying usage trends, determining the effectiveness
                        of our promotional campaigns and to evaluate and improve
                        our Services, products, marketing and your experience.
                        We may use and store this information in aggregated and
                        anonymized form so that it is not associated with
                        individual end users and does not include personal
                        information. We will not use identifiable personal
                        information without your consent.
                    </li>
                </ul>
                <h2>3. SMS/Text Messaging</h2>
                <p>
                    In Short: If you provide your mobile number and consent, we
                    may send you text messages. You can opt out at any time.
                </p>
                <ul>
                    <li>
                        What our text messages are used for. If you provide your
                        mobile phone number and consent, we may send you SMS/text
                        messages relating to your inquiry, appointment or
                        case-related updates, customer service and support, and
                        marketing or promotional communications about our
                        Services.
                    </li>
                    <li>
                        How you provide consent. You provide consent to receive
                        text messages by submitting your mobile phone number
                        through our forms, by opting in where offered, or by
                        otherwise expressly agreeing to be contacted by text.
                        Consent to receive marketing text messages is not a
                        condition of purchasing any goods or services.
                    </li>
                    <li>Message frequency. Message frequency varies.</li>
                    <li>
                        Message and data rates. Message and data rates may apply.
                    </li>
                    <li>
                        Opt-out and help. Reply STOP to unsubscribe at any time.
                        Reply HELP for assistance. You may also contact us at
                        privacy@reliancelitigation.com.
                    </li>
                    <li>
                        No sharing of mobile opt-in data. No mobile information
                        will be shared with third parties or affiliates for
                        marketing or promotional purposes. Text messaging
                        originator opt-in data and consent will not be shared
                        with any third parties.
                    </li>
                </ul>
                <h2>4. Will Your Information Be Shared With Anyone?</h2>
                <p>
                    In Short: We only share information with your consent, to
                    comply with laws, to provide you with services, to protect
                    your rights, or to fulfill/ business obligations.
                </p>
                <p>
                    We may process or share data based on the following legal
                    basis
                </p>
                <p />
                <ul>
                    <li>
                        Consent: We may process your data if you have given us
                        specific consent to use your personal information in a
                        specific purpose.
                    </li>
                    <li>
                        Legitimate Interests: We may process your data when it
                        is reasonably necessary to achieve our legitimate
                        business interests.
                    </li>
                    <li>
                        Performance of a Contract: Where we have entered into a
                        contract with you or another business, we may process
                        your personal information to fulfill the terms of our
                        contract.
                    </li>
                    <li>
                        Legal Obligations: We may disclose your information
                        where we are legally required to do so in order to
                        comply with applicable law, governmental requests, a
                        judicial proceeding, court order. or legal process, such
                        as in response to a court order or a subpoena (including
                        in response to public authorities to meet national
                        security or law enforcement requirements).
                    </li>
                    <li>
                        Vital Interests: We may disclose your information where
                        we believe it is necessary to investigate, prevent, or
                        take action regarding potential violations of our
                        policies suspected fraud, situations involving potential
                        threats to the safety of any person and illegal
                        activities, or as evidence in litigation in which we are
                        involved. More specifically, we may need to process your
                        data or share your personal information in the following
                        situations
                    </li>
                    <li>
                        Third Party Businesses: We provide marketing,
                        consulting, lead generation, and advertising services to
                        third party businesses, including law firms, that pay us
                        for those services. We generally contact prospective
                        clients on their behalf rather than providing the
                        information you submit to them, and any such business is
                        subject to signed contracts with us governing the use of
                        our services.
                    </li>
                    <li>
                        Vendors, Consultants and Other Third-Party Service
                        Providers: We may share your data with third party
                        vendors, service providers, contractors or agents who
                        perform services for us or on our behalf and require
                        access to such information to do that work. Examples
                        include: payment processing, data analysis, email
                        delivery, hosting services, customer service and
                        marketing efforts. We may allow selected third parties
                        to use tracking technology on the Services, which will
                        enable them to collect data about how you interact with
                        the Services over time. This information may be used to.
                        among other things, analyze and track data, determine
                        the popularity of certain content and better understand
                        on line activity.
                    </li>
                    <li>
                        Business Transfers: We may share or transfer your
                        information in connection with, or during negotiations
                        of, any merger, sale of company assets, financing or
                        acquisition of all or a portion of our business to
                        another company.
                    </li>
                    <li>
                        Third-Party Advertisers:. We may use third-party
                        advertising companies to serve ads when you visit the
                        Services These companies may use information about your
                        visits to our Website(s) and other websites that are
                        contained in web cookies and other tracking technologies
                        in order to provide advertisements about goods and
                        services of interest to you.
                    </li>
                    <li>
                        Business Partners: We may share your information with
                        our business partners to offer you certain products,
                        services or promotions.
                    </li>
                </ul>
                <p>
                    Notwithstanding anything above, mobile information and text
                    messaging (SMS) opt-in data and consent are excluded from the
                    sharing described in this section. No mobile information will
                    be shared with third parties or affiliates for marketing or
                    promotional purposes, and text messaging originator opt-in
                    data and consent will not be shared with any third parties.
                </p>
                <h2>5. Do We Use Cookies and Other Tracking Technologies?</h2>
                <p />
                In Short: We may use cookies and other tracking technologies to
                collect and store your information
                <p>
                    We may use cookies and similar tracking technologies (like
                    web beacons and pixels) to access or store information.
                    Specific information about how we use such technologies and
                    how you can refuse certain cookies is set out in our Cookie
                    Policy
                </p>
                <h2>6. How Long Do We Keep Your Information?</h2>
                <p>
                    In Short: We keep your information for as long as necessary
                    to fulfill/ the purposes outlined in this privacy policy
                    unless otherwise required by law
                </p>
                <p>
                    We will only keep your personal information for as long as
                    it is necessary for the purposes set out in this privacy
                    policy. unless a longer retention period is required or
                    permitted by law (such as tax, accounting or other legal
                    requirements). No purpose in this policy will require us
                    keeping your personal information for longer than 2 years.
                    When we have no ongoing legitimate business need to process
                    your personal information, we will either delete or
                    anonymize it, or, if this is not possible (for example,
                    because your personal information has been stored in backup
                    archives), then we will securely store your personal
                    information and isolate it from any further processing until
                    deletion is possible.
                </p>
                <h2>7. How Do We Keep Your Information Safe?</h2>
                <p>
                    In Short: We aim to protect your personal information
                    through a system of organizational and technical security
                    measures
                </p>
                <p>
                    We have implemented appropriate technical and organizational
                    security measures designed to protect the security of any
                    personal information we process However, please also
                    remember that we cannot guarantee that the internet itself
                    is 100% secure. Although we will do our best to protect your
                    personal information, transmission of personal information
                    to and from our Services is at your own risk. You should
                    only access the services within a secure environment.
                </p>
                <h2>8. What Are Your Privacy Rights?</h2>
                <p>
                    In Short: You may review, update, or request deletion of the
                    personal information we hold about you, and opt out of our
                    marketing communications, at any time.
                </p>
                <p>
                    You may request access to, correction of, or deletion of the
                    personal information we have collected about you by
                    submitting our opt-out form or contacting us at
                    privacy@reliancelitigation.com. We will respond to your
                    request as required by applicable law.
                </p>
                <p>
                    Cookies and similar technologies: Most Web browsers are set
                    to accept cookies by default. If you prefer. you can usually
                    choose to set your browser to remove cookies and to reject
                    cookies. If you choose to remove cookies or reject cookies.
                    this could affect certain features or services of our
                    Services.
                </p>
                <p>
                    To opt-out of our marketing list, you may fill out our{" "}
                    <a href="http://policies.reliancelitigation.com/opt-out">
                        opt-out form
                    </a>{" "}
                    or contact us at privacy@reliancelitigation.com.
                </p>
                <h2>9. Controls for Do-Not-Track Features</h2>
                <p>
                    Most web browsers and some mobile operating systems and
                    mobile applications include a Do-Not-Track ("DNT") feature
                    or setting you can activate to signal your privacy
                    preference not to have data about your online browsing
                    activities monitored and collected No uniform technology
                    standard for recognizing and implementing DNT signals has
                    been finalized. As such, we do not currently respond to DNT
                    browser signals or any other mechanism that automatically
                    communicates your choice not to be tracked on line If a
                    standard for on line tracking is adopted that we must follow
                    in the future, we will inform you about that practice in a
                    revised version of this privacy policy.
                </p>
                <h2>
                    10. Do California Residents Have Specific Privacy Rights?
                </h2>
                <p>
                    In Short: Yes, if you are a resident of California, you are
                    granted specific rights regarding access to your personal
                    information
                </p>
                <p>
                    California residents can request and obtain from us your
                    information that we’ve collected and to whom we’ve shared
                    your data with. You also have the right to request the
                    removal or deletion of your data. We do not however have
                    control of third-party data that we have either obtained or
                    shared as part of our Services. We can only fulfill your
                    requests to the information that we have in our records.
                </p>
                <p>
                    If you are a California resident and would like to make such
                    a request, please submit your request on our{" "}
                    <a href="http://policies.reliancelitigation.com/opt-out">
                        opt-out form
                    </a>{" "}
                    or contact us at privacy@reliancelitigation.com.
                </p>
                <p>
                    We may have to contact you to verify that you are a
                    California resident before we can disclose or delete the
                    information that we have on your behalf. We will try to
                    respond to your request within 30 business days.
                </p>
                <h2>11. Do We Make Updates to This Policy?</h2>
                <p>
                    In Short: Yes, we will update this policy as necessary to
                    stay compliant with relevant laws
                </p>
                <p>
                    We may update this privacy policy from time to time. The
                    updated version will be indicated by an updated Revised"
                    date and the updated version will be effective as soon as it
                    is accessible. If we make material changes to this privacy
                    policy, we may notify you either by prominently posting a
                    notice of such changes or by directly sending you a
                    notification We encourage you to review this privacy policy
                    frequently to be informed of how we are protecting your
                    information.
                </p>
                <h2>12. How Can You Contact Us About This Policy?</h2>
                <p>
                    If you have questions or comments about this policy, you may
                    email us at privacy@reliancelitigation.com or by mail to:
                </p>
                <p>
                    Reliance Litigation, LLC
                    <br />
                    21550 Oxnard St, FL 3<br />
                    Woodland Hills, CA 91367
                    <br />
                    United States
                    <br />
                    <br />
                    Phone: (888) 856-7299
                    <br />
                </p>
            </div>
        </div>
    );
}

export default Privacy;
